var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperClipWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.644,
    height: 15.99,
    viewBox: "0 0 17.644 15.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g610",
    transform: "translate(306.931 555.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path612",
    d: "M-298.392-541.128l7.445-7.445a3.958,3.958,0,0,0,0-5.6h0a3.958,3.958,0,0,0-5.6,0l-8.818,8.818a2.936,2.936,0,0,0,0,4.152h0a2.936,2.936,0,0,0,4.152,0l6.961-6.961a1.914,1.914,0,0,0,0-2.706h0a1.914,1.914,0,0,0-2.706,0l-5.588,5.588",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClipWhite);
export default __webpack_public_path__ + "static/media/paper-clip-white.c03f123f4d6080e684b4338196abece6.svg";
export { ForwardRef as ReactComponent };